export default __webpack_public_path__ + "static/media/CNo.80-0.0ae3e452.jpg";